import { Icon } from "components/index";
import { IMAGE } from "icons";
import React from "react";
import { assetUrl } from "utils/index";

const ProjectNameCell = ({ row }) => {
  const logo = row.original.logo;
  const name = row.original.name;

  return (
    <div className="flex items-center gap-2">
      <div className="overflow-hidden rounded size-8">
        {logo ? (
          <img
            src={assetUrl(logo)}
            alt={`${name} logo`}
            className="w-full h-full object-contain"
          />
        ) : (
          <div className="w-full h-full  flex items-center justify-center rounded bg-neutral">
            <Icon icon={IMAGE} className="size-full text-input" />
          </div>
        )}
      </div>
      <span>{name}</span>
    </div>
  );
};

export default ProjectNameCell;
